import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';

export default function CountryForm() {

    const policyFormSchema: DynamicFormSchema = {
        layout: 'vertical', // Overall form layout
        showResetButton: true, // Show a reset button

        // Define form sections for better organization and complex layouts
        sections: [
            {
                key: 'Country',
                title: 'Country',
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        name: 'name',
                        label: 'Name',
                        type: 'input',
                        required: true,
                        colSpan: 12,
                    }
                ],
            },
        ]

    };

    return (
        <DynamicForm
            schema={policyFormSchema}
            getByIdApiUrl={API_ENDPOINTS.LOOKUP.GET_COUNTRY_BY_ID}
            updateApiUrl={API_ENDPOINTS.LOOKUP.UPDATE_COUNTRY}
            refreshTableDataKey={QUERY_KEYS.LOOKUP.COUNTRY}
        />
    );
}
